import {
  AssortmentCategoryType,
  AssortmentState,
} from 'b2b-apps/shop/assortment/redux/types';
import { RemoteRecord } from 'b2b-apps/shop/common/redux/RemoteRecord';
import { State } from 'b2b-apps/shop/common/redux/types';

const getState = (state: State): AssortmentState => state.assortment.ownAssortment;

const getOwnAssortment = (
  state: State,
): RemoteRecord<AssortmentCategoryType[]> => new RemoteRecord(getState(state));

export {
  getOwnAssortment,
  getState,
};
